const queryOrgStorage = `
query GetOrgStorage($orgId: ID!) {
  org_storages(
    first: 1
    where: { org_pointer: { have: { objectId: { equalTo: $orgId } } } }
    order: [updatedAt_DESC]
  ) {
    count
    edges {
      node {
        objectId
        total_bytes
        total_files
        breakdown
        createdAt
        updatedAt
      }
    }
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export default queryOrgStorage;
